<template>
  <div class="slider-wrapper" @touchmove.stop.prevent>
    <div class="slider-header">
      <div class="slider-cancel" @click="cancel">取消</div>
      <div class="slider-conform" @click="conform">确定</div>
    </div>
    <sliding-block
      @scrolling="scrolling"
      @selectChange="change"
      @scrollend="scrollend"
      @click.stop
      :options="options"
      :value="value"
    >
      <div class="slider-select"></div>
    </sliding-block>
  </div>
</template>
<style scoped>
.slider-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.slider-cancel,
.slider-conform {
  text-align: center;
  padding: 0 30px;
  font-size: 34px;
  line-height: 80px;
  height: 80px;
}

.slider-cancel {
  color: #666;
}

.slider-conform {
  color: #ff9c00;
}

.slider-wrapper {
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 11;
  width: 100%;
  background-color: #fff;
}

.slider-select {
  position: absolute;
  top: 50%;
  transform: translate3d(0, -50%, 0);
  box-sizing: border-box;
  width: 100%;
  border-top: 1px solid #ddd; /*no*/
  height: 80px;
  border-bottom: 1px solid #ddd; /*no*/
  z-index: 1;
}
</style>
<script>
import slidingBlock from './sliding-block'

export default {
  data () {
    return {
      temp: null
    }
  },
  props: ['value', 'options'],
  methods: {
    cancel () {
      this.$emit('close')
    },
    conform () {
      this.$emit('close', this.temp)
    },
    scrolling () {
      this.$emit('scrolling')
    },
    scrollend () {
      this.$emit('scrollend')
    },
    change (val) {
      this.temp = val
    }
  },
  components: {
    'sliding-block': slidingBlock
  }
}
</script>
